export function isFileImage(fileType = "") {
    const isImage =
        fileType === "png" ||
        fileType === "jpeg" ||
        fileType === "jpg" ||
        fileType === "webp" ||
        fileType === "image" ||
        fileType === "photo" ||
        fileType?.startsWith("image") ||
        fileType?.startsWith("photo");
    
    return isImage
}